import { Breadcrumb, Button } from "antd";
import { HomeOutlined, RightOutlined } from "@ant-design/icons";

export function FolderBreadcrumb({ breadcrumbs, onNavigate }) {
  return (
    <div
      style={{
        maxWidth: "100%",
        overflowX: "auto",
        whiteSpace: "nowrap",
        paddingBottom: "4px",
      }}
    >
      <Breadcrumb
        separator={<RightOutlined style={{ paddingTop: 10 }} />}
        style={{ marginBottom: 16, display: "inline-block" }}
        items={breadcrumbs.map((breadcrumb, index) => ({
          key: index,
          title: (
            <Button
              type="text"
              onClick={() => onNavigate(breadcrumb.path)}
              style={{
                padding: "2px 6px",
                textOverflow: "ellipsis",
                justifyContent: "center",
                overflow: "hidden",
                display: "flex",
                alignItems: "center",
                whiteSpace: "nowrap",
              }}
            >
              {index === 0 ? <HomeOutlined /> : breadcrumb.name}
            </Button>
          ),
        }))}
      />
    </div>
  );
}
